var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislikeOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.0001L6 13.9886V2.98851L2 2.99998L2 14.0001Z",
    stroke: "#F56A50",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 19.4828C17.15 21.3142 14 21.3142 14 20.3985C14.2441 16.1771 12.1273 14.2385 10.5363 13.2946C10.2129 13.1027 10 12.7633 10 12.3873V4.50002C10 3.94773 10.4473 3.50001 10.9996 3.50002L16 3.5C17 3.49989 16.7 3.5 18.5 3.5C19.5 3.5 20.6689 4.74252 21 6C21.3312 7.25748 22 10.5843 22 11.5C22 12.4157 21.9 13.9886 20.1 13.9886H18.1489C17.5966 13.9886 17.15 14.4363 17.15 14.9886V19.4828Z",
    stroke: "#F56A50",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeOutline);
export default __webpack_public_path__ + "static/media/dislike-outline.9de81af8b7727aac2d62a25eb5540524.svg";
export { ForwardRef as ReactComponent };